// =============================================================================
// Topic page mobile nav — at ≤820px the sidebar topic list collapses into a
// native <select> (see _topic-page.scss); picking an option navigates to that
// topic. The control is hidden on wider viewports, where the sidebar nav is
// the navigation, so the handler simply no-ops elsewhere.
// =============================================================================

function init() {
	const select = document.querySelector("[data-aa-topic-select]");
	if (!select) return;

	select.addEventListener("change", () => {
		if (select.value) {
			window.location.href = select.value;
		}
	});
}

if ("loading" === document.readyState) {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
